import React from 'react';
import { cn } from '@/lib/utils';
import { Check, GripVertical } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { ColumnDef } from '@/hooks/useReportBuilder';

interface Props {
  columns: ColumnDef[];
  selected: string[];
  onToggle: (key: string) => void;
}

const TYPE_COLORS: Record<string, string> = {
  text: 'bg-blue-500/10 text-blue-600',
  number: 'bg-emerald-500/10 text-emerald-600',
  date: 'bg-violet-500/10 text-violet-600',
  boolean: 'bg-amber-500/10 text-amber-600',
};

export const ColumnPicker: React.FC<Props> = ({ columns, selected, onToggle }) => (
  <div className="space-y-1.5">
    <div className="flex items-center justify-between px-1">
      <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Colunas</p>
      <span className="text-xs text-muted-foreground">{selected.length}/{columns.length} selecionadas</span>
    </div>
    <div className="grid grid-cols-1 gap-1">
      {columns.map(col => {
        const active = selected.includes(col.key);
        return (
          <button
            key={col.key}
            onClick={() => onToggle(col.key)}
            className={cn(
              'flex items-center gap-2.5 rounded-md border px-3 py-2 text-left transition-colors group',
              active
                ? 'border-primary/50 bg-primary/5 text-foreground'
                : 'border-border/50 bg-background text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
          >
            <GripVertical className="h-3 w-3 text-muted-foreground/30 shrink-0" />
            <div className={cn(
              'h-4 w-4 rounded shrink-0 border flex items-center justify-center transition-colors',
              active ? 'bg-primary border-primary' : 'border-border'
            )}>
              {active && <Check className="h-2.5 w-2.5 text-primary-foreground" strokeWidth={3} />}
            </div>
            <span className="flex-1 text-sm font-medium truncate">{col.label}</span>
            <Badge variant="outline" className={cn('text-xs px-1 py-0 leading-none shrink-0 border-0', TYPE_COLORS[col.type])}>
              {col.type}
            </Badge>
          </button>
        );
      })}
    </div>
  </div>
);
